export default __webpack_public_path__ + "static/media/brownPinkWhiteNoise.a5db3b01.wav";